import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { AddModuleSchema } from '@app/models/orders';
import Api from '@app/services/api';

interface IParams {
  moduleData: AddModuleSchema;
  uid: string;
}

export const useCreateProcessModuleQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ moduleData, uid }: IParams) => {
      await Api.orders.postAddModule(uid, moduleData);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async (data) => {
      await client.invalidateQueries(['getProcess']);
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
      return data;
    },
  });
};
